import { HOSTNAME, ACCOUNT_DOMAIN } from '@/CONSTS'
/**
 * アカウントサーバーとAPI接続する際に環境によって接続先を変更する
 * @return { String } - それぞれの環境で接続するアカウントサーバーのホスト名
 */
export default () => {
  switch (window.location.host) {
    case HOSTNAME.DEM:
      return ACCOUNT_DOMAIN.DEM
      break
    case HOSTNAME.DEV:
      return ACCOUNT_DOMAIN.DEV
      break
    case HOSTNAME.STG:
      return ACCOUNT_DOMAIN.STG
      break
    case HOSTNAME.PRD:
      return ACCOUNT_DOMAIN.PRD
      break
    default:
      return process.env.MIX_ACCOUNT_API_URL_LCL || ACCOUNT_DOMAIN.LCL
      break
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utils/getAuthHost.js